"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TypesenseError_1 = __importDefault(require("./TypesenseError"));
class RequestMalformed extends TypesenseError_1.default {
}
exports.default = RequestMalformed;
//# sourceMappingURL=RequestMalformed.js.map